<section id="mu-unavailable" class="mu-cant-access">
  <div class="p-grid">
    <div class="p-col-12 mu-without-padding">
      <img src="assets/images/common/img-unavailable.svg" alt="" />
    </div>
    <h1 class="p-col-12 mu-without-padding" [innerHTML]="'common.unavailable.title' | translate"></h1>
    <p class="p-col-12 mu-without-padding" [innerHTML]="'common.unavailable.text' | translate"></p>
    <p class="p-col-12 mu-without-padding" [innerHTML]="'common.unavailable.retry' | translate" (click)="retry()"></p>
  </div>
</section>
